import { Cancel } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';

const FilePreview = ({ attachments, handleRemoveImage, submitting }) => {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, mt: attachments?.length > 0 ? 1.5 : 0 }}>
      {attachments &&
        attachments.map((file, index) => {
          let fileURL;
          let fileType;
          let fileName;

          if (file instanceof File || file instanceof Blob) {
            fileURL = URL.createObjectURL(file);
            fileType = file.type;
            fileName = file.name;
          } else if (file && file.url) {
            fileURL = file.url;
            fileType = file.content_type || '';
            fileName = file.file_name || 'file';
          } else {
            return null;
          }

          const isImage = fileType.startsWith('image');

          return (
            <Box
              key={index}
              sx={{
                position: 'relative',
                width: 80,
                height: 80,
                border: '2px solid',
                borderColor: 'divider',
                borderRadius: 1,
                overflow: 'hidden',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'background.default',
              }}
            >
              {isImage ? (
                <Box
                  component="img"
                  src={fileURL}
                  alt={`file-preview-${index}`}
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              ) : (
                <Box
                  sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'grey.100',
                    borderRadius: 0.5,
                  }}
                >
                  <Typography variant="caption" color="text.secondary">
                    {fileName.split('.').pop().toUpperCase()}
                  </Typography>
                </Box>
              )}

              <IconButton
                sx={{
                  position: 'absolute',
                  top: 8,
                  right: 8,
                  transform: 'translate(50%, -50%)',
                  color: 'error.main',
                  p: 0,
                }}
                disabled={submitting}
                onClick={() => handleRemoveImage(index)}
                size="small"
              >
                <Cancel sx={{ fontSize: 20 }} />
              </IconButton>
            </Box>
          );
        })}
    </Box>
  );
};

export default FilePreview;